import { useEffect, useState } from "react";

function getDefaultSorting(defaultTableData, columns) {
    const sorted = [...defaultTableData].sort((a, b) => {
        const filterColumn = columns.filter((column) => column.sortbyOrder);

        // Merge all array objects into single object and extract accessor and sortbyOrder keys
        let { accessor = "id", sortbyOrder = "asc" } = Object.assign(
            {},
            ...filterColumn
        );

        if (a[accessor] === null) return 1;
        if (b[accessor] === null) return -1;
        if (a[accessor] === null && b[accessor] === null) return 0;

        const ascending = a[accessor]
            .toString()
            .localeCompare(b[accessor].toString(), "en", {
                numeric: true,
                // Date filter
                
            });

        return sortbyOrder === "asc" ? ascending : -ascending;
    });
    return sorted;
}

export const useSortableTable = (data, columns) => {

    const [tableData, setTableData] = useState(getDefaultSorting(data, columns));

    useEffect(() => {
        const nextRowsById = new Map(data.map((row) => [row.id, row]));

        setTableData((currentRows) => {
            if (!currentRows.length || currentRows.length !== data.length) {
                return getDefaultSorting(data, columns);
            }

            const currentRowIds = currentRows.map((row) => row.id);
            const nextRowIds = data.map((row) => row.id);
            const hasSameRowIds = currentRowIds.every((rowId) => nextRowsById.has(rowId));
            const hasSameOrder = currentRowIds.every((rowId, index) => rowId === nextRowIds[index]);

            if (!hasSameRowIds) {
                return getDefaultSorting(data, columns);
            }

            if (hasSameOrder) {
                return data;
            }

            return currentRows.map((row) => nextRowsById.get(row.id) || row);
        });
    }, [columns, data]);

    const handleSorting = (sortField, sortOrder) => {
        if (sortField) {
            const sorted = [...tableData].sort((a, b) => {
                if (a[sortField] === null) return 1;
                if (b[sortField] === null) return -1;
                if (a[sortField] === null && b[sortField] === null) return 0;
                return (
                    a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
                        numeric: true,
                    }) * (sortOrder === "asc" ? 1 : -1)
                );
            });
            setTableData(sorted);
        }
    };

    return [tableData, handleSorting];
};
